import { HandPointingIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Pointer = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <HandPointingIcon color={fill} {...rest} size={Sizes[size]} />;
};

Pointer.displayName = 'Pointer';
